import {
  ApolloLink,
  FetchResult,
  NextLink,
  Observable,
  Operation,
} from "@apollo/client";
import { store } from "@redux";
import { version as projectVersion } from "../../../../web/src/projectVersion";

interface ICustomHeaders {
  Authorization?: string | undefined;
  // headers for app identification
  'x-app-name': string;
  'x-app-version': string;
  'x-app-channel': string;
}

const operationsWithoutToken = ['codeExchange','idpSignUp']
/* istanbul ignore next */
export const authLink = new ApolloLink(
  (
    operation: Operation,
    forward?: NextLink
  ): Observable<FetchResult> | null => {
    if (!forward) {
      return null;
    }
    const operationName = operation.operationName;
    const headers: ICustomHeaders = {
      "x-app-name": 'FOODI',
      'x-app-channel': 'WEB',
      'x-app-version': projectVersion,
    };

    const token = store.getState().auth.authToken?.accessToken;
    const shouldAddToken = !operationsWithoutToken.includes(operationName)

    // Avoid to send token for some operations
    if (shouldAddToken && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    operation.setContext({
      headers,
    });

    return forward(operation);
  }
);
